// import React, { useState, useRef, useEffect } from "react";
// // import DropDownIcon from "../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
// import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
// export default function DropDown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   style,
//   className, // Add this line
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabel, setSelectedLabel] = useState("");
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef]);

//   const handleClick = (option) => {
//     setSelected(option.id); // Pass the ID of the selected option
//     setIsActive(false);
//     console.log("Selected option ID:", option.id); // Log the ID of the selected option
//     setSelectedLabel(option.label);
//   };

//   return (
//     <div
//       className={`dropdown-CB ${className}`}
//       style={{ width, ...style }}
//       ref={dropdownRef}
//     >
//       <label className="dropdown-CB-label">
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div className="dropdown-btn" onClick={() => setIsActive(!isActive)}>
//         {selectedLabel}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content-CBV2"
//           style={{ width: customWidth, top: customTop }}
//         >
//           {options.map((option) => (
//             <div
//               key={option.id}
//               className="dropdown-item-CBV2"
//               onClick={() => handleClick(option)}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";

// export default function DropDown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   style,
//   className,
//   disabled = false, // ✅ new prop with default false
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabel, setSelectedLabel] = useState("");
//   const dropdownRef = useRef(null);

//   // Update label
//   useEffect(() => {
//     const found = options.find((opt) => opt.id === selected);
//     setSelectedLabel(found ? found.label : "");
//   }, [selected, options]);

//   // Close on outside click
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleClick = (option) => {
//     if (disabled) return;
//     setSelected(option.id);
//     setSelectedLabel(option.label);
//     setIsActive(false);
//   };

//   const toggleDropdown = () => {
//     if (!disabled) {
//       setIsActive(!isActive);
//     }
//   };

//   return (
//     <div
//       className={`dropdown-CB ${className || ""}`}
//       style={{
//         width,
//         opacity: disabled ? 0.5 : 1,
//         pointerEvents: disabled ? "none" : "auto",
//         ...style,
//       }}
//       ref={dropdownRef}
//     >
//       <label className="dropdown-CB-label">
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div className="dropdown-btn" onClick={toggleDropdown}>
//         {selectedLabel || "Select"}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content-CBV2"
//           style={{ width: customWidth, top: customTop }}
//         >
//           {options.map((option) => (
//             <div
//               key={option.id}
//               className="dropdown-item-CBV2"
//               onClick={() => handleClick(option)}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";

// export default function DropDown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options = [],
//   customWidth,
//   customTop,
//   isRequired,
//   style,
//   className,
//   disabled = false,
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabel, setSelectedLabel] = useState("");
//   const dropdownRef = useRef(null);

//   // Ensure selectedLabel is always in sync
//   useEffect(() => {
//     if (!options || options.length === 0) return;

//     const selectedOption = options.find(
//       (opt) => String(opt.id) === String(selected)
//     );

//     if (selectedOption) {
//       setSelectedLabel(selectedOption.label);
//       console.log("Selected option ID:", selectedOption.id); // Log the ID of the selected option
//     } else {
//       setSelectedLabel(""); // fallback if no match
//     }
//   }, [selected, options]);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleClick = (option) => {
//     if (disabled) return;
//     setSelected(option.id); // parent state
//     setSelectedLabel(option.label); // local label
//     setIsActive(false);
//   };

//   const toggleDropdown = () => {
//     if (!disabled) setIsActive(!isActive);
//   };

//   return (
//     <div
//       className={`dropdown-CB ${className || ""}`}
//       style={{
//         width,
//         opacity: disabled ? 0.5 : 1,
//         pointerEvents: disabled ? "none" : "auto",
//         ...style,
//       }}
//       ref={dropdownRef}
//     >
//       <label className="dropdown-CB-label">
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div className="dropdown-btn" onClick={toggleDropdown}>
//         {selectedLabel || "Select"}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content-CBV2"
//           style={{ width: customWidth, top: customTop }}
//         >
//           {options.map((option) => (
//             <div
//               key={option.id}
//               className="dropdown-item-CBV2"
//               onClick={() => handleClick(option)}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }









import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";

export default function DropDown({
  width,
  label,
  selected,
  setSelected,
  options = [],
  customWidth,
  customTop,
  isRequired,
  style,
  className,
  disabled = false,
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!options || options.length === 0) return;
    const selectedOption = options.find(
      (opt) => String(opt.id) === String(selected)
    );
    if (selectedOption) {
      setSelectedLabel(selectedOption.label);
    } else {
      setSelectedLabel("");
    }
  }, [selected, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClick = (option) => {
    if (disabled) return;
    setSelected(option.id);
    setSelectedLabel(option.label);
    setIsActive(false);
  };

  const toggleDropdown = () => {
    if (!disabled) setIsActive(!isActive);
  };

  return (
    <div
      className={`dropdown-CB ${className || ""}`}
      style={{
        width,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
        ...style,
      }}
      ref={dropdownRef}
    >
      <label
        className="dropdown-CB-label"
        style={{
          fontSize: "14px",
          color: "var(--DppLabelText, #6A6A6A)",
          display: "block",
          marginBottom: "5px",
        }}
      >
        {label}
        {isRequired && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
      </label>
      <div
        className="dropdown-btn"
        onClick={toggleDropdown}
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          color: "var(--Gray-2, #6A6A6A)",
          fontSize: "14px",
          borderRadius: "0px",
          backgroundColor: "var(--DppInputBackground, #ffffff)",
          border: "1px solid var(--DppInputBorder, #d0d0d0)",
        }}
      >
        {selectedLabel || "Select"}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-content-CBV2"
          style={{ width: customWidth, top: customTop, fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item-CBV2"
              onClick={() => handleClick(option)}
              style={{ fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
